export default __webpack_public_path__ + "static/media/ate0.b8cba6c4.png";